<script setup>
import { useI18n } from 'vue-i18n';
import Footer from '@/components/landing/Footer.vue';
import PrivacyPolicyList from '@/components/PrivacyPolicyList.vue';
import LandingPageNavBar from '@/components/navigation/LandingPageNavigationBar.vue';

const { t } = useI18n();

const imprints = [
  {
    id: 1,
    title: t('terms&condition.generalCondition.title'),
    content: t('terms&condition.generalCondition.content'),
  },
  {
    id: 2,
    title: t('terms&condition.scope.title'),
    content: t('terms&condition.scope.content'),
  },
  {
    id: 3,
    title: t('terms&condition.conclusion.title'),
    content: t('terms&condition.conclusion.content'),
  },
  {
    id: 4,
    title: t('terms&condition.withdrawal.title'),
    content: t('terms&condition.withdrawal.content'),
  },
  {
    id: 5,
    title: t('terms&condition.defaultPayment.title'),
    content: t('terms&condition.defaultPayment.content'),
  },
  {
    id: 6,
    title: t('terms&condition.retention.title'),
    content: t('terms&condition.retention.content'),
  },
  {
    id: 7,
    title: t('terms&condition.delivery.title'),
    content: t('terms&condition.delivery.content'),
  },
  {
    id: 8,
    title: t('terms&condition.warranty.title'),
    content: t('terms&condition.warranty.content'),
  },
  {
    id: 9,
    title: t('terms&condition.liability.title'),
    content: t('terms&condition.liability.content'),
  },
  {
    id: 10,
    title: t('terms&condition.dataProtection.title'),
    content: t('terms&condition.dataProtection.content'),
  },
  {
    id: 11,
    title: t('terms&condition.final.title'),
    content: t('terms&condition.final.content'),
  },
  {
    id: 12,
    title: t('terms&condition.disputeResolution.title'),
    content: t('terms&condition.disputeResolution.content'),
  },
];
</script>

<template>
  <LandingPageNavBar />

  <PrivacyPolicyList
    :title="t('terms&condition.title')"
    :imprints="imprints"
  />

  <Footer />
</template>

<style scoped></style>
